module.exports = __webpack_public_path__ + "static/media/codequiz.7bb2e863.png";